import { parseEther } from "viem"
import { isMaster } from "../constants/server"

export const TOKEN_TOTAL_SUPPLY = parseEther((1_000_000_000).toString()) // 1 billion tokens

/**
 * ParagraphCoinFactory addresses for each chain.
 */
export const COIN_FACTORY_ADDRESSES: Record<number, `0x${string}`> = {
  84532: "0x498B41Fed29CA2c8501d2A14a091bCF14Cefa136", // Base Sepolia
}

/**
 * The chain ID that the Coin is on.
 *
 * On master, always Base mainnet.
 *
 * On preview branches, Base sepolia.
 *
 * Note that this works on both the backend and the frontend.
 */
export const COIN_CHAIN = isMaster ? 8453 : 84532
